import api from "../../api/axios.config"
import { setDressModelDetail } from "../slices/dressDetails/dressDetailsSlice"

export const getDressModelById = (id) => {
    return async (dispatch, getState) => {
        const result = await api.get(`api/dress-models/${id}`);
        dispatch(setDressModelDetail(result.data.data));
    }
}